import React from 'react';
import paper from '../ReportPaper.module.css';
import MotorMilestonesPanel from '../../../../pages/appointment/components/motorMilestones/MotorMilestonesPanel';
import MotorMilestonesTable from '../../../../pages/appointment/components/motorMilestones/MotorMilestonesTable';
import styles from '../../../../pages/appointment/components/motorMilestones/motorMilestones.module.css';
import { WHO_MOTOR_ATTRIBUTION, gestationalLabel } from '../../../../pages/appointment/modules/motorMilestones/motorMilestones';
import { formatAge } from '../../../../pages/appointment/modules/growth/growthIndicators';

/**
 * Miolo do PDF dos marcos motores: idade (e idade corrigida), o gráfico das
 * janelas da OMS e a lista dos marcos com situação, data e idade. O gráfico é
 * SVG só com traços e texto (o html2canvas não desenha imagem dentro de SVG).
 *
 * Recebe o job de buildMotorMilestonesJob.
 */
const MotorMilestonesReportBody = ({ rows, current, corrected, birthInfo }) => {
  const gestational = gestationalLabel(birthInfo);
  const ages = [
    current && `Idade: ${formatAge(current.chronological)}`,
    current && current.corrected != null && `Idade corrigida: ${formatAge(current.corrected)}`,
    gestational && `Idade gestacional ao nascer: ${gestational}`,
  ].filter(Boolean);

  return (
    <>
      {ages.length > 0 && (
        <div className={paper.section}>
          <div className={paper.noteBox}>{ages.join(' · ')}</div>
        </div>
      )}

      <div className={paper.section}>
        <div className={paper.sectionTitle}>Janelas de conquista</div>
        <MotorMilestonesPanel rows={rows} current={current} corrected={corrected} currentLabel="Na emissão" />
      </div>

      <div className={paper.section}>
        <div className={paper.sectionTitle}>Marcos</div>
        <MotorMilestonesTable rows={rows} classes={{ table: paper.table }} />
      </div>

      <span className={styles.attribution}>{WHO_MOTOR_ATTRIBUTION}</span>
    </>
  );
};

export default MotorMilestonesReportBody;
